import {
  IsBoolean,
  IsNumber,
  IsOptional,
  IsUUID,
  Max,
  Min,
} from 'class-validator';
import { BaseCreateDto, BaseUpdateDto } from '../base.dto';
import type { BaseDto } from '../base.dto';
import type { NamedEntityDto } from '../clinical-details/named.dto';

export interface TrainingConditionImageDto extends BaseDto {
  focalPointX?: number;
  focalPointY?: number;
  url?: string;
  isBlurry?: boolean;
  isReferenceOnly?: boolean;
  isDiscarded?: boolean;
  hasArrow?: boolean;
  imageType: NamedEntityDto;
  difficultyIndex?: number | null;
  thumbnailXsUrl?: string;
  thumbnailSUrl?: string;
  thumbnailMUrl?: string;
  thumbnailLUrl?: string;
  thumbnailXlUrl?: string;
  /**
   * @deprecated use thumbnailXlUrl instead. Kept temporarily for backwards compatabi
   */
  thumbnailXLUrl?: string;
}

export class CreateTrainingConditionImageDto extends BaseCreateDto {
  @IsUUID()
  imageTypeId: string;

  @IsUUID()
  trainingConditionId: string;
}

export class UpdateTrainingConditionImageDto extends BaseUpdateDto {
  @IsOptional()
  @IsBoolean()
  isBlurry?: boolean;

  @IsOptional()
  @IsBoolean()
  isReferenceOnly?: boolean;

  @IsOptional()
  @IsBoolean()
  isOriginalCrop?: boolean;

  @IsOptional()
  @IsBoolean()
  isDiscarded?: boolean;

  @IsOptional()
  @IsBoolean()
  hasArrow?: boolean;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @Max(1)
  focalPointX?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @Max(1)
  focalPointY?: number;

  @IsOptional()
  @IsNumber()
  arrowPointX?: number;

  @IsOptional()
  @IsNumber()
  arrowPointY?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @Max(1)
  difficultyIndex?: number;

  @IsOptional()
  @IsNumber()
  followUpTimeMonths?: number;
}
